import './styles.css';

type Match = {
  id: string;
  court: string;
  teamA: string;
  teamB: string;
  scoreA: number;
  scoreB: number;
};

const storageKey = 'kob.matches.v1';

const seedMatches: Match[] = [
  { id: crypto.randomUUID(), court: 'Court 1', teamA: 'Falcons', teamB: 'Otters', scoreA: 0, scoreB: 0 },
  { id: crypto.randomUUID(), court: 'Court 2', teamA: 'Pandas', teamB: 'Rockets', scoreA: 0, scoreB: 0 },
];

let matches = loadMatches();

function loadMatches(): Match[] {
  const raw = localStorage.getItem(storageKey);
  if (!raw) return seedMatches;

  try {
    return JSON.parse(raw) as Match[];
  } catch {
    return seedMatches;
  }
}

function saveMatches() {
  localStorage.setItem(storageKey, JSON.stringify(matches));
}

function updateScore(id: string, side: 'A' | 'B', delta: number) {
  matches = matches.map((match) => {
    if (match.id !== id) return match;
    const key = side === 'A' ? 'scoreA' : 'scoreB';
    return { ...match, [key]: Math.max(0, match[key] + delta) };
  });
  saveMatches();
  render();
}

function resetScores() {
  matches = matches.map((match) => ({ ...match, scoreA: 0, scoreB: 0 }));
  saveMatches();
  render();
}

function render() {
  const app = document.querySelector<HTMLDivElement>('#app');
  if (!app) return;

  app.innerHTML = `
    <section class="hero">
      <p class="eyebrow">Cloudflare Pages + Functions shell</p>
      <h1>Volleyball tournament scoreboard</h1>
      <p>Start here: client-side app state lives in <code>src/main.ts</code>. A tiny Pages Function lives at <code>/api/health</code>.</p>
      <div class="actions">
        <button id="reset">Reset scores</button>
        <a href="/api/health">Check API</a>
      </div>
    </section>

    <section class="grid">
      ${matches.map(matchTemplate).join('')}
    </section>
  `;

  app.querySelector('#reset')?.addEventListener('click', resetScores);
  app.querySelectorAll<HTMLButtonElement>('[data-score]').forEach((button) => {
    button.addEventListener('click', () => {
      const [id, side, delta] = button.dataset.score!.split(':') as [string, 'A' | 'B', string];
      updateScore(id, side, Number(delta));
    });
  });
}

function matchTemplate(match: Match) {
  return `
    <article class="card">
      <p class="court">${match.court}</p>
      ${teamTemplate(match, 'A')}
      ${teamTemplate(match, 'B')}
    </article>
  `;
}

function teamTemplate(match: Match, side: 'A' | 'B') {
  const name = side === 'A' ? match.teamA : match.teamB;
  const score = side === 'A' ? match.scoreA : match.scoreB;

  return `
    <div class="team">
      <strong>${name}</strong>
      <div class="scoreControls">
        <button data-score="${match.id}:${side}:-1" aria-label="Subtract point from ${name}">−</button>
        <span class="score">${score}</span>
        <button data-score="${match.id}:${side}:1" aria-label="Add point to ${name}">+</button>
      </div>
    </div>
  `;
}

render();
